import type { ReactNode } from 'react';
import type { ConversationView, MessageView } from '../../api/client';
import { PatchGoingBar, PatchInButton, PatchNoteJoin } from '../../components/PatchMessages';
import { TeamClock } from '../../components/messages/LocalTime';

/**
 * Places in the Messages page that features built alongside it (Patches) fill in, kept in this
 * file so they can be added without reworking the page: the conversation header's actions, a
 * bar under the header, and extras on the line of a note from Stitch (a Patch started). Each
 * shows nothing until something is added here.
 */
export interface ConversationExtrasProps {
  /** The company's tenant. */
  domain: string;
  conversation: ConversationView;
  /** The signed-in person. */
  myId: string;
}

/** Buttons beside the conversation's own, at the right of its header ("Patch in"). */
export function HeaderExtras(props: ConversationExtrasProps): ReactNode {
  return <PatchInButton domain={props.domain} conversation={props.conversation} />;
}

/** Bars under the conversation's header ("Patch going: Sam, Joey · Join", and a channel's team clock). */
export function UnderHeaderExtras(props: ConversationExtrasProps): ReactNode {
  return (
    <>
      <PatchGoingBar domain={props.domain} conversation={props.conversation} />
      <TeamClock domain={props.domain} c={props.conversation} myId={props.myId} />
    </>
  );
}

/** After the words of a note from Stitch (a Join button on "Joey started a Patch"). */
export function SystemMessageExtras(props: ConversationExtrasProps & { message: MessageView }): ReactNode {
  if (props.message.meta?.type !== 'patch.started') return null;
  return <PatchNoteJoin domain={props.domain} conversation={props.conversation} message={props.message} />;
}
